import Splide from '@splidejs/splide';
import {stripSplideSlideRoleAttributes} from './splideAccessibility';

export function initNewsSlider(): void {
    document.querySelectorAll<HTMLElement>('.news-slider__splide').forEach((element) => {
        const splide = new Splide(element, {
            label: element.dataset.splideLabel || '',
            type: 'slide',
            fixedWidth: 246,
            perMove: 1,
            gap: '14px',
            drag: true,
            snap: true,
            arrows: false,
            pagination: false,
            mediaQuery: 'min',
            breakpoints: {
                768: {
                    fixedWidth: 410,
                    perMove: 1,
                    gap: '24px',
                },
                992: {
                    fixedWidth: 444,
                    perMove: 1,
                },
            },
        }).mount();

        stripSplideSlideRoleAttributes(element);

        const carousel = element.closest('.news-slider__carousel');
        if (!carousel) return;

        const prevBtn = carousel.querySelector<HTMLButtonElement>('.news-slider__arrow--prev');
        const nextBtn = carousel.querySelector<HTMLButtonElement>('.news-slider__arrow--next');

        prevBtn?.addEventListener('click', () => splide.go('<'));
        nextBtn?.addEventListener('click', () => splide.go('>'));

        // A3: count non-hidden slides — reliable with fixedWidth where perPage is dynamic
        function getVisibleCount(): number {
            return element.querySelectorAll('.splide__slide:not([aria-hidden="true"])').length || 1;
        }

        function updateArrowState(): void {
            const visible = getVisibleCount();
            if (prevBtn) prevBtn.disabled = splide.index === 0;
            if (nextBtn) nextBtn.disabled = splide.index + visible >= splide.length;
        }

        splide.on('mounted move resize', updateArrowState);

        // A4: live region announces current position to screen readers
        const liveRegion = document.createElement('div');
        liveRegion.className = 'visually-hidden';
        liveRegion.setAttribute('aria-live', 'polite');
        liveRegion.setAttribute('aria-atomic', 'true');
        carousel.appendChild(liveRegion);

        // A4: descriptive position text instead of ambiguous "2 / 6"
        splide.on('moved', (newIndex) => {
            liveRegion.textContent = `${newIndex + 1} von ${splide.length}`;
        });

        // Prevent card link clicks from firing after a drag (distance-based)
        let dragStartX = 0;
        let dragMoved = false;
        const DRAG_THRESHOLD = 8; // px

        element.addEventListener('pointerdown', (e: PointerEvent) => {
            dragStartX = e.clientX;
            dragMoved = false;
        });
        // A3: skip hover — only track movement when a pointer button is held
        element.addEventListener('pointermove', (e: PointerEvent) => {
            if (e.buttons === 0) return;
            if (Math.abs(e.clientX - dragStartX) > DRAG_THRESHOLD) dragMoved = true;
        });
        // A2: reset flag when the pointer is released so future clicks are not blocked
        element.addEventListener('pointerup', () => { dragMoved = false; });
        element.addEventListener('pointercancel', () => { dragMoved = false; });
        element.querySelectorAll<HTMLAnchorElement>('.splide__slide a').forEach((link) => {
            link.addEventListener('click', (e) => { if (dragMoved) e.preventDefault(); });
        });
    });
}
